// Copied from:
// https://github.com/transferwise/neptune-web/blob/5e97eae7a6b0575faf7853b802a35a000459472c/packages/components/src/common/hooks/useClientWidth/useClientWidth.js
import throttle from 'lodash.throttle';
import { useLayoutEffect, useState, useEffect } from 'react';

const THROTTLE_MS = 100;

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export const useClientWidth = ({ ref, throttleMs = THROTTLE_MS }) => {
  const [clientWidth, setClientWidth] = useState(null);

  useIsomorphicLayoutEffect(() => {
    // eslint-disable-next-line unicorn/consistent-function-scoping
    const updateClientWidth = () => {
      if (ref) {
        // when `ref` is a window
        if (ref.innerWidth) {
          setClientWidth(ref.innerWidth);
        }
        // when `ref` is an element
        else if (ref.current) {
          setClientWidth(ref.current.clientWidth);
        }
      }
    };
    // This assignment saves a reference to the function so it will be the same passed to both addEventListener removeEventListener.
    // If throttle gets passed directly to both add and removeEventListenet the results will be that the event
    // won't get removed even if the component is unmounted.
    const attachedFunction = throttle(updateClientWidth, throttleMs);

    window.addEventListener('resize', attachedFunction, true);

    updateClientWidth();

    return () => window.removeEventListener('resize', attachedFunction, true);
  }, []);

  return [clientWidth];
};

// eslint-disable-next-line fp/no-mutation
useClientWidth.THROTTLE_MS = THROTTLE_MS;
